import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  PlatformContact,
  FindPlatformContactsQueryQuery
} from "../../../../../../schemaTypes";

export const findPlatformContactsQuery = gql`
  query FindPlatformContactsQuery {
    findPlatformContacts {
      id
      facebook
      x
      linkedin
      instagram
      logoUrl
      email
      website
      address
      updatedAt
      createdAt
    }
  }
`;

export const newPlatformContactSubscription = gql`
  subscription NewPlatformContactSubscription {
    newPlatformContact {
      id
      facebook
      x
      linkedin
      instagram
      logoUrl
      email
      website
      address
      updatedAt
      createdAt
    }
  }
`;

type NewPlatformContactSubscriptionResult = {
  newPlatformContact: PlatformContact;
};

export function useFindPlatformContacts() {
  const { data, loading, subscribeToMore } = useQuery<FindPlatformContactsQueryQuery>(findPlatformContactsQuery);

  React.useEffect(() => {
    if (!subscribeToMore) return;
    const unsubscribe = subscribeToMore({
      document: newPlatformContactSubscription,
      updateQuery: (prev, { subscriptionData }: { subscriptionData: { data?: NewPlatformContactSubscriptionResult } }) => {
        if (!subscriptionData.data) return prev;
        return {
          ...prev,
          findPlatformContacts: [
            ...prev.findPlatformContacts,
            subscriptionData.data.newPlatformContact
          ]
        };
      }
    });
    return () => unsubscribe();
  }, [subscribeToMore]);

  return {
    platformContacts: data?.findPlatformContacts ?? [],
    loading
  };
}
